import { render, staticRenderFns } from "./BottomNav.vue?vue&type=template&id=60408023&scoped=true"
import script from "./BottomNav.vue?vue&type=script&lang=js"
export * from "./BottomNav.vue?vue&type=script&lang=js"
import style0 from "./BottomNav.vue?vue&type=style&index=0&id=60408023&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60408023",
  null
  
)

export default component.exports